import { ContentEntity, GroupAdditionMethodEnum, GroupTypeEnum, UserType } from '@/types/schema';

import useContentCollections from './useContentCollections';
import useUserGroups from './useUserGroups';

export default function useGroupItems({
  groupId,
  type,
  searchText,
}: {
  groupId: string;
  type: GroupTypeEnum;
  searchText: string;
}) {
  const {
    learners,
    isFetchingMore: fetchingMoreLearners,
    isFetching: isFetchingLearners,
    isLoading: isLoadingLearners,
    fetchMore: fetchMoreLearners,
    totalCount: totalGroups,
    refetch: refetchLearners,
  } = useUserGroups({
    filters: {
      groupFilter: { groupIds: [groupId], groupAdditionMethod: GroupAdditionMethodEnum.All },
      searchText,
    },
    groupId,
    pause: !groupId || type !== GroupTypeEnum.UserCollection,
  });

  const {
    contents,
    isFetchingMore: fetchingMoreContents,
    isFetching: isFetchingContents,
    isLoading: isLoadingContents,
    fetchMore: fetchMoreContents,
    totalCount: totalContents,
    refetch: refetchContents,
  } = useContentCollections({
    filters: {
      groupFilter: { groupIds: [groupId], groupAdditionMethod: GroupAdditionMethodEnum.All },
      name: searchText,
      fetchEventContainers: true,
    },
    groupId: groupId!,
    pause: !groupId || type !== GroupTypeEnum.ContentCollection,
  });

  if (type === GroupTypeEnum.UserCollection) {
    return {
      // TODO @HimanshuSahu31 refactor explicit typecast
      data: learners as UserType[],
      isFetchingMore: fetchingMoreLearners,
      isFetching: isFetchingLearners,
      isLoading: isLoadingLearners,
      fetchMore: fetchMoreLearners,
      totalCount: totalGroups,
      refetch: refetchLearners,
    };
  }

  return {
    // TODO @HimanshuSahu31 refactor explicit typecast
    data: contents as ContentEntity[],
    isFetchingMore: fetchingMoreContents,
    isFetching: isFetchingContents,
    isLoading: isLoadingContents,
    fetchMore: fetchMoreContents,
    totalCount: totalContents,
    refetch: refetchContents,
  };
}
